// extracted by mini-css-extract-plugin
export default {"filtersContainer":"questionAndAnswerFilters_filtersContainer__Gn1CC","customLabel":"questionAndAnswerFilters_customLabel__y0myT"};